"use client";

import { Button } from "@/components/ui/Button";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { useState } from "react";

export function SidebarHeader({ expanded, setPinned }: { expanded: boolean; setPinned: (v: boolean) => void }) {
  const [logoHovered, setLogoHovered] = useState(false);
  return (
        <div className={`flex h-16 items-center gap-2 ${expanded ? "px-3" : "justify-center px-2"}`}>
          {expanded ? (
            <div className="flex w-full items-center gap-2">
              <Button variant="ghost" iconOnly className="shrink-0" onClick={(e) => {
                  e.stopPropagation();
                  setPinned(false);
                }} aria-label="Collapse sidebar" title="Collapse sidebar">
                <PanelLeftClose size={17} />
              </Button>
              {/* Real logo asset, not a text wordmark — self-hosted at
                  public/evia-logo.png rather than hotlinked from the
                  company's marketing site (evia-services.com) as this
                  used to be. Hotlinking a third-party site for a piece of
                  core nav chrome is fragile regardless — this app has no
                  control over that URL staying valid, and it's one
                  plausible explanation for logo-rendering reports that
                  didn't match what the code alone would predict. Only
                  rendered when expanded — the collapsed state's copy
                  lives inside the button below instead. `h-7` (not the
                  button's `h-6`) — this one stands alone next to
                  full-size text rather than sharing a cramped 36px
                  button, so it can afford to read a touch bigger without
                  feeling squeezed. */}
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img data-no-dim
                src="/evia-logo.png"
                alt="evia"
                className="h-7 w-auto shrink-0 dark:brightness-0 dark:invert"
              />
              <div className="flex min-w-0 flex-col justify-center">
                <span className="line-clamp-2 text-[11px] font-bold tracking-wider text-subtle leading-tight sm:text-xs sm:leading-none sm:tracking-[0.09em]">
                  HUB
                </span>
              </div>
            </div>
          ) : (
            <Button variant="ghost" iconOnly className="group relative shrink-0" onClick={(e) => {
                e.stopPropagation();
                setPinned(true);
              }} onMouseEnter={() => setLogoHovered(true)} onMouseLeave={() => setLogoHovered(false)} aria-label="Expand sidebar" title="Expand sidebar">
              {/* The source asset is the full icon+wordmark lockup
                  (~3.46:1 aspect ratio) — there's no separate icon-only
                  crop available from the company's site, and cropping it
                  down to just the "e" via object-fit/object-position
                  turned out not to render reliably here. A plain
                  gradient badge sidesteps that entirely — no image
                  loading or cross-browser object-fit behavior to depend
                  on, guaranteed to render, and still reads as the brand
                  (same blue-to-green the real logo actually uses, sampled
                  from the asset itself: #049AD9 -> #75AB36). */}
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white transition-opacity duration-100 ${
                  logoHovered ? "opacity-0" : "opacity-100"
                }`}
                style={{ background: "linear-gradient(135deg, #049AD9, #75AB36)" }}
              >
                e
              </span>
              <span
                className={`absolute inset-0 flex items-center justify-center text-subtle transition-opacity duration-100 ${
                  logoHovered ? "opacity-100" : "opacity-0"
                }`}
              >
                <PanelLeftOpen size={17} />
              </span>
            </Button>
          )}
        </div>
  );
}
